import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Draggable } from 'react-beautiful-dnd'
import RowData from '../RowData'

import styles from './styles.module.scss'

class Rows extends Component {
  getRowData(row, key, dndProps = {}) {
    const { isSelectedRow, onSelectRow, withReorder, dragging, labels, children } = this.props

    return (
      <RowData
        labels={labels}
        data={row}
        selected={isSelectedRow && isSelectedRow(row)}
        dataGridDragging={dragging}
        withReorder={withReorder}
        onSelectRow={onSelectRow}
        key={key}
        {...dndProps}
      >
        {children}
      </RowData>
    )
  }

  render() {
    const { rows, withReorder } = this.props

    if (withReorder) {
      return rows.map((row, index) => (
        <Draggable key={row.id} draggableId={row.id} index={index}>
          {(draggableProvided, draggableSnapshot) => {
            const { innerRef, draggableProps, dragHandleProps } = draggableProvided

            return (
              <>
                {this.getRowData(row, row.id, {
                  innerRef,
                  draggableProps,
                  dragHandleProps,
                  dragging: draggableSnapshot.isDragging,
                })}
                {draggableProvided.placeholder && (
                  <div className={styles.placeholderWrapper}>{draggableProvided.placeholder}</div>
                )}
              </>
            )
          }}
        </Draggable>
      ))
    }

    return rows.map(row => this.getRowData(row, row.id))
  }
}

Rows.defaultProps = {
  isSelectedRow: undefined,
  onSelectRow: undefined,
  withReorder: false,
  dragging: false,
}

Rows.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  labels: PropTypes.arrayOf(PropTypes.node).isRequired,
  isSelectedRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  withReorder: PropTypes.bool,
  dragging: PropTypes.bool,
}

export default Rows
